/**
 * Resource that represents a Sale type of Movement.
 *
 * @name MovementSale
 * @class
 * @augments TmrResource
 */
function MovementSaleFactory(TmrApi, TmrResource, tmrMovementTypes) {
  'ngInject'
  let actions = {
    status: {
      method: 'POST',
      url: TmrApi.endpoint('MovementSale.status'),
    },
  }
  let MovementSale = TmrResource('MovementSale', actions)
  let prevStatus = MovementSale.status

  MovementSale.status = status
  MovementSale.sale = sale
  MovementSale.getTypeDescription = getTypeDescription
  MovementSale.prototype.$getTypeDescription = getTypeDescription

  /**
   * Simulates a sale to place movement collecting epc status
   *
   * @method MovementSale#status
   * @param {Place} destinationPlace The destination place
   * @param {array<Item>} items The Items of the operation
   * @param {string} description An optional description of the movement
   */
  function status(destinationPlace, items, description) {
    if (typeof destinationPlace !== 'object') {
      throw new Error(
        'MovementOutbound.status() action requires a destination Place'
      )
    }
    if (!Array.isArray(items) || items.length == 0) {
      throw new Error(
        'MovementSale.status(place, items, description) action requires an array of Items'
      )
    }
    return prevStatus.call(this, { destinationPlace, items, description })
  }

  /**
   * Performs a sale to place movement
   *
   * @method MovementSale#sale
   * @param {Place} destinationPlace The destination place
   * @param {array<Item>} items The Items of the operation
   * @param {string} description An optional description of the movement
   */
  function sale(destinationPlace, items, description) {
    if (typeof destinationPlace !== 'object') {
      throw new Error(
        'MovementOutbound.status() action requires a destination Place'
      )
    }
    if (!Array.isArray(items) || items.length == 0) {
      throw new Error(
        'MovementSale.sale(place, items, description) action requires an array of Items'
      )
    }
    return this.save({ destinationPlace, items, description })
  }

  /**
   * Return Movement type description.
   *
   * @method Movement#getTypeDescription
   */
  function getTypeDescription() {
    return tmrMovementTypes[this.type]
  }

  return MovementSale
}

export const factory = ['MovementSale', MovementSaleFactory]
